export const customEn = {
  StepsTitle: 'Meet Single Truckers Near You Today'
};
export const customEs = {
  StepsTitle: 'Conoce camioneros solteros cerca de ti hoy'
};
export const customDa = {
  StepsTitle: 'Mød single lastbilchauffører nær dig i dag'
};
export const customDe = {
  StepsTitle: 'Triff heute Single-Trucker in deiner Nähe'
};
export const customFi = {
  StepsTitle: 'Tapaa sinkku rekkakuskeja lähelläsi tänään'
};
export const customSv = {
  StepsTitle: 'Möt singel lastbilschaufförer nära dig idag'
};
export const customFr = {
  StepsTitle: 'Rencontrez des chauffeurs routiers célibataires près de chez vous aujourd’hui'
};
export const customHu = {
  StepsTitle: 'Találkozz egyedülálló kamionsofőrökkel a közeledben még ma!'
};
